import { createContext } from "react";
import { defaultSettings } from "./appsettings/defaultSettings";

export const AppSettingsContext = createContext(defaultSettings);
